import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { usePermissions } from '@/features/permissions';
import type { PatientMetadata } from '../api/patients-api';
import { UploadedDocumentInboxSheet } from './UploadedDocumentInboxSheet';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function ReferralHistory({ metadata }: { metadata?: PatientMetadata | null }) {
  const { can } = usePermissions();
  const [source, setSource] = useState<NonNullable<PatientMetadata['referral_history']>[number]>();
  const fields = ['medical_history', 'obstetric_history', 'surgical_history', 'family_history', 'social_history', 'medications'] as const;
  return <Card>
    <CardHeader><CardTitle>History and referral records</CardTitle></CardHeader>
    <CardContent className="flex flex-col gap-4">
      <p>Use Edit to maintain the history. Source statements remain available below, including conflicting demographics.</p>
      {fields.map((field) => <div key={field}><strong>{field.replaceAll('_', ' ')}</strong><p className="whitespace-pre-wrap">{metadata?.[field] || 'Not documented'}</p></div>)}
      <details><summary>Imported source statements ({metadata?.referral_history?.length || 0})</summary>
        <div className="flex flex-col gap-4 pt-4">{metadata?.referral_history?.map((entry, i) => <div key={i}>
          <strong>{entry.field.replaceAll('_', ' ')}{entry.conflict && ' · differs from current chart; current value preserved'}</strong>
          <p className="whitespace-pre-wrap">{entry.value}</p>
          {can('read_document') && <Button variant="link" onClick={() => setSource(entry)}>Source{entry.page && ` · page ${entry.page}`}</Button>}
        </div>)}</div>
      </details>
      <UploadedDocumentInboxSheet open={!!source} pageNumber={source?.page} documentId={source?.document_id}
        revisionId={source?.revision_id} onOpenChange={(open) => { if (!open) setSource(undefined); }} />
    </CardContent>
  </Card>;
}
